// extracted by mini-css-extract-plugin
export default {"lineClamp":"SJwxVRSQv4yrSNJGd1QZ","gap":"zUn14nXD2deAMai9hT06","skeleton":"fju0iSx9rpV1bNHhKYY5","pulse":"wK7leAnM1TuiiyNbGrVG","table-striped":"dsxnK6Ugj3jxDWzhlJ9c"};